import { store } from './configureStore'
import { UserActions } from './combinedActions'

export default () => {
  store.dispatch(UserActions.getFilterGroups())
}
